"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stack = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _grid = require("./grid");
var _excluded = ["direction", "children", "divider", "sx"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// There exists a Stack within Material UI v5, but we are currently behind on this (also due to React 16).
// We aim to have a similar API for an eventual switch over.
// References:
// https://mui.com/components/stack/
// https://mui.com/api/stack/
var DEFAULT_DIRECTION = 'column';

// This value is multiplied by 8px and results in a 24px gutter between elements
var DEFAULT_SPACING = 3;
var Stack = exports.Stack = function Stack(_ref) {
  var direction = _ref.direction,
    children = _ref.children,
    divider = _ref.divider,
    sx = _ref.sx,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  // converting React.Children into an array filters out nulls
  var childrenArray = React.Children.toArray(children);
  return /*#__PURE__*/React.createElement(_grid.Grid, (0, _extends2["default"])({
    container: true,
    direction: direction || DEFAULT_DIRECTION,
    spacing: DEFAULT_SPACING,
    "data-provides": "stack"
  }, rest, {
    sx: sx
  }), childrenArray && childrenArray.map(function (child, childNum) {
    var isLast = childNum === childrenArray.length - 1;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: childNum
    }, /*#__PURE__*/React.createElement(_grid.Grid, {
      item: true
    }, child), divider && !isLast && /*#__PURE__*/React.createElement(_grid.Grid, {
      item: true,
      role: "separator"
    }, divider));
  }));
};